import sportFormDictionary from '../../ru/sport-form/sport-form.dic.json';

export const sportFormNS = {
  SPORT_FORM: sportFormDictionary,
};

export const sportFormNamespaces = ['SPORT_FORM'];
